"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDropMediaEndpoint = void 0;
const endpointIds_1 = require("root/src/shared/descriptions/endpoints/endpointIds");
const lenses_1 = require("root/src/shared/descriptions/endpoints/lenses");
exports.getDropMediaEndpoint = {
    [endpointIds_1.GET_DROP_MEDIA]: {
        endpointType: lenses_1.otherEndpointType,
        payloadSchema: {
            type: 'object',
            properties: {
                dropMnemonicId: { type: 'string' },
            },
            required: ['dropMnemonicId'],
        },
    },
};
